import { render } from "./component-customer-group.vue?vue&type=template&id=2ed29486"
import script from "./component-customer-group.vue?vue&type=script&setup=true&lang=js"
export * from "./component-customer-group.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-customer-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ed29486"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ed29486', __exports__)) {
    api.reload('2ed29486', __exports__)
  }
  
  module.hot.accept("./component-customer-group.vue?vue&type=template&id=2ed29486", () => {
    api.rerender('2ed29486', render)
  })

}


export default __exports__